import {useState} from 'react';
import { NavigateFunction } from 'react-router-dom';
import Swal, {SweetAlertIcon} from 'sweetalert2';
// @ts-ignore
import LoadingOverlay from 'react-loading-overlay';

// Apis
import { forgotPasswordApi } from '../../api/auth';

// Components
import Form from '../Common/Form';
import {validateInputs} from '../Common/Form/Inputs';

// Context
import { useTranslationStore } from '../../context/Translation';

// Enums
import { ImageSources } from '../../enums/Images';
import { InputTypes } from '../../enums/Inputs';
import { SwalIcons, SwalTitle } from '../../enums/Swal';
import { RoutesLinks } from '../../enums/Routes';
import { LanguageResource } from '../../enums/Languages';

// Interfaces
import { InputInterface } from '../../interfaces/Input';

interface PropsInterface {
  navigate: NavigateFunction
}

const ForgotPasswordPage = (props: PropsInterface) => {
  const [t] = useTranslationStore(),
    [email, setEmail] = useState(''),
    [isLoading, setIsLoading] = useState(false),
    inputs: InputInterface[] = [
      {
        name: "email",
        type: InputTypes.Email,
        placeholder: true,
        onChange: (val: string) => setEmail(val),
        value: email,
        required: true
      }
    ];

  const handleSubmit = () => {
    setIsLoading(true);
    const valid = validateInputs(inputs, t);
    if (valid) {
      const trimmedEmail = email.toLowerCase().trim();
      forgotPasswordApi({email: trimmedEmail}, (err: any) => {
        setIsLoading(false);
        if (err) {
          Swal.fire({
            icon: SwalIcons.Error as SweetAlertIcon,
            title: t(SwalTitle.Error),
            text: err,
          });
        } else {
          Swal.fire({
            icon: SwalIcons.Success as SweetAlertIcon,
            title: t(SwalTitle.Success),
            text: t(LanguageResource.Auth + ':forgot_password_success'),
          }).then(() => {
            props.navigate(RoutesLinks.Login.Link);
          });
        }
      });
    } else {
      setIsLoading(false);
    }
  }

  return (
    <div className='login-wrapper'>
      <LoadingOverlay
        active={isLoading}
        spinner
      >
        <div className='login-form-wrapper' onSubmit={() => handleSubmit()}>
          <img src={require('../../' + ImageSources.LogoBlue.url)} alt={ImageSources.LogoBlue.name} width='50px'/>
          <img src={require('../../' + ImageSources.NameBlue.url)} alt={ImageSources.NameBlue.name} width='100px'/>
          <p className='text-weight-bold text-size-default'>{t(LanguageResource.Auth + ':forgot_password_sub_title')}</p>
          <Form 
            inputs={inputs}
            onSubmit={handleSubmit}
          />
          <div className="row-wrapper">
            <p className="text-color-main text-weight-bold text-size-small" onClick={() => props.navigate(RoutesLinks.Login.Link)}>
              {t(LanguageResource.Common + ':cancel')}
            </p>
            <p onClick={() => handleSubmit()} className="submit-button">&#8594;</p>
          </div>
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default ForgotPasswordPage;